import {
  Button,
  Grid,
  Typography,
  LinearProgress,
  styled,
  withStyles,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export const CheckCircleIconGreen = styled(CheckCircleIcon)(({ theme }) => ({
  color: theme.palette.success.main,
  fontSize: "4.5rem",
}));

export const BorderLinearProgress = withStyles({
  root: {
    height: 10,
    borderRadius: 5,
  },
  bar: {
    borderRadius: 5,
  },
})(LinearProgress);

export const ButtonPadding = styled(Button)(({ theme }) => ({
  margin: theme.spacing(4),
}));

export const GridProcess = styled(Grid)(({ theme }) => ({
  width: "90%",
  padding: theme.spacing(4),
}));

export const GridDetails = styled(Grid)(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(4, 4, 0, 4),
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  textTransform: "uppercase",
}));

export const Details = styled(Grid)(({ theme }) => ({
  overflowY: "auto",
  height: 50,
  padding: theme.spacing(0, 2),
  margin: theme.spacing(2, 2, 0, 2),
}));

export const Message = styled(Typography)(({ theme }) => ({
  display: "block",
  fontSize: "0.8rem",
  textAlign: "center",
  padding: theme.spacing(0, 4),
  margin: theme.spacing(0),
}));
